<!-- Copyright 2023, Common Good Learning Tools LLC -->
<template><k-dialog v-model="dialog_open" max-width="900" persistent scrollable><v-card>
	<v-card-title style="background-color:#eee"><v-icon color="#000" class="mr-3">fas fa-list-check</v-icon><b>{{site_config.app_name}}: {{alt_patch?site_config.patch_register_alt_text.title : 'Free Registration'}}</b></v-card-title>
	<v-card-text class="mt-1" style="font-size:16px; line-height:21px;">
		<div v-if="alt_patch" class="pink lighten-5 pa-2 mt-2 mb-3 black--text" style="border-radius:6px;">{{site_config.patch_register_alt_text.description}}</div>
		<div v-else class="pink lighten-5 pa-2 mt-2 mb-3 black--text" style="border-radius:6px;">Common Good Learning Tools (CGLT) is pleased to allow anyone to <b>author and publish up to 5 CASE® frameworks in a free “patch” of {{site_config.app_name}}</b>. The video below briefly explains the process of setting up a patch, creating a new framework, adding competencies to your framework, publishing it to the world, and accessing it using {{site_config.app_name}} or the CASE APIs.</div>
		<p v-if="!alt_patch" class="text-center">
			<iframe width="400" height="252" :src="site_config.registration_video_link" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
		</p>
		<div v-if="alt_patch" class="pink lighten-5 pa-2 mt-2 mb-3 black--text" style="border-radius:6px;">{{site_config.patch_register_alt_text.instructions}}</div>
		<div v-else class="pink lighten-5 pa-2 mt-2 mb-3 black--text" style="border-radius:6px;">Fill out and submit the following form to create your free {{site_config.app_name}} patch and get started with CASE publishing! Email <a :href="`mailto:support@commongoodlt.com?subject=${site_config.app_noun} inquiry`"><b>support@commongoodlt.com</b></a> if you have questions.</div>

		<div class="d-flex mt-5">
			<k-text-field class="mr-3" outlined dense hide-details label="*Organization name" v-model="organization" placeholder=""></k-text-field>
			<div style="width:200px">
				<v-select v-model="organization_type" :items="organization_types" label="*Organization Type" outlined dense hide-details append-icon="fas fa-caret-down"></v-select>
			</div>
			<div style="width:240px">
				<k-text-field class="ml-3" outlined dense hide-details label="*Job title" v-model="org_job_title" placeholder=""></k-text-field>
			</div>
		</div>

		<div class="d-flex mt-6">
			<div style="flex:0 0 28%"><k-text-field class="mr-3" outlined dense hide-details label="*First name" v-model="first_name" placeholder=""></k-text-field></div>
			<div style="flex:0 0 28%"><k-text-field class="mr-3" outlined dense hide-details label="*Last name" v-model="last_name" placeholder=""></k-text-field></div>
			<div style="flex:0 0 44%"><k-text-field outlined dense hide-details label="*Email" v-model="email" placeholder=""></k-text-field></div>
		</div>

		<div class="d-flex align-center justify-center mt-6">
			<div class="mr-3 text-right">*Enter a 4-or-more-letter <b>subdomain</b> of satchelcommons.com to use for your patch<br>(subdomains are not case-sensitive):</div>
			<div style="width:120px"><v-text-field outlined dense hide-details label="" v-model="subdomain" placeholder=""></v-text-field></div>
		</div>

		<div class="mt-6">
			<div class="mb-2">Optionally enter a <b>“site headline”</b> to appear at the top of the Framework Index page for your patch. (You may want to include a link to your organization in your site headline.)</div>
			<froala-wrapper 
				:config="U.get_froala_config()"
				v-model="site_headline" 
			/>
			<div class="mt-2 text-center"><i style="font-size:14px">(Note that you will be able edit your subdomain and patch description later.)</i></div>
		</div>

		<div v-if="!alt_patch" class="d-flex mt-6">
			<v-textarea outlined hide-details label="*Let us know, in a sentence or two, why you’re interested in CASE publishing" rows="3" v-model="reason" placeholder=""></v-textarea>
		</div>

		<!-- <div class="d-flex mt-6">
			<k-checkbox class="mt-0 pt-0 d-inline-block" style="vertical-align:bottom" hide-details off-icon="far fa-square" on-icon="fas fa-check-square"
				v-model="tos_clicked"
			><template v-slot:label><span>To submit your registration request, please read and agree with the {{site_config.app_name}} <a @click.stop="show_tos"><b>TERMS OF SERVICE</b></a></span></template>
			</k-checkbox>
		</div> -->

	</v-card-text>
	<v-card-actions class="pa-3" style="border-top:1px solid #999; background-color:#eee">
		<v-btn color="secondary" @click="$emit('dialog_cancel')"><v-icon small class="mr-2">fas fa-xmark</v-icon>Cancel</v-btn>
		<v-spacer/>
		<div style="font-size:14px" class="mr-2">*Required fields</div>
		<v-btn color="primary" :disabled="!form_complete" @click="submit">{{alt_patch?site_config.patch_register_alt_text.submit: 'Register Your Free Patch '}}<v-icon small class="ml-2">fas fa-circle-arrow-right</v-icon></v-btn>
	</v-card-actions>
</v-card></k-dialog></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		// req: { type: String, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		dialog_open: true,

		first_name: '',
		last_name: '',
		email: '',
		organization: '',
		organization_type: '',
		org_job_title: '',
		reason: '',
		subdomain: '',
		site_headline: '',
		tos_clicked: false,

		// first_name: 'Sima',
		// last_name: 'Lation',
		// email: 'simalation503@gmail.com',
		// organization: 'Negative Campus',
		// organization_type: 'non_public_agency',
		// org_job_title: 'Programmerr',
		// reason: 'I need to do it',
		// subdomain: 'NX',
		// site_headline: '<p>This is my site. <a href="https://www.example.com" target="_blank" rel="noopener noreferrer">example.com</a></p>',
		// tos_clicked: true,

		// keep this in sync with AdminUserEdit and ExchangeRegister
		organization_types: [
			{ value: 'public_agency', text: 'Public agency (e.g. state DOE, country MOE, school, school district)' },
			{ value: 'non_public_agency', text: 'Non-public agency (e.g. charter school networks, nonprofit organizations)' },
			{ value: 'ed_tech_company', text: 'Ed-tech company' },
		],
	}},
	computed: {
		...mapState(['site_config', 'user_info']),
		...mapGetters([]),
		form_complete() {
			if (empty(this.first_name.trim())) return false
			if (empty(this.last_name.trim())) return false
			if (empty(this.email.trim())) return false
			if (empty(this.organization.trim())) return false
			if (empty(this.organization_type.trim())) return false
			if (empty(this.org_job_title.trim())) return false
			if (empty(this.reason.trim()) && empty(this.site_config.patch_register_alt_text)) return false
			if (empty(this.subdomain.trim())) return false
			// if (!this.tos_clicked) return false
			return true
		},
		alt_patch() {
			if (empty(this.site_config.patch_register_alt_text)) return false
			return true
		},
	},
	watch: {
	},
	created() {
	},
	mounted() {
	},
	methods: {
		show_tos() { 
			vapp.satchel_tos_showing = true 
			setTimeout(x=>this.tos_clicked = false)
		},
		submit() {
			// most validation happened above
			let subdomain = this.subdomain.trim().toUpperCase()
			let domain = (this.alt_patch) ? this.site_config.patch_register_alt_text.patch_domain : 'satchelcommons.com'

			// make sure subdomain is >= 4 characters
			if (subdomain.length < 4) {
				this.$alert('Your subdomain must be at least 4 characters long.')
				return
			}

			// check if the subdomain category already exists
			let category_records = U.create_category_records(this.$store.getters.filtered_framework_records, false, false)
			if (category_records.find(x=>x.map_label == subdomain)) {
				this.$alert(`The subdomain you entered (${subdomain}) is already taken; please try a different one.`)
				return
				// note that newly-created subdomains that don't have frameworks might not be caught here; 
				// but we'll catch those when we submit to the server
			}



			let email_body_html = 
				`Your ${this.site_config.app_name} Patch, at <a href="https://${subdomain.toLowerCase()}.${domain}">https://${this.subdomain.toLowerCase()}.${domain}</a>, has been created, and a ${this.site_config.app_name} user account has been created for your email address (${this.email.trim()}), with rights to create and manage frameworks for this Patch.<br/><br/>`
				+ `Click the following link to sign in for the first time. This link can only be used once, and will expire in 24 hours. After clicking the link to sign in, you can set or change your account password. (If you fail to click this link within 24 hours, you can always click the SIGN IN button from ${this.site_config.app_name}, then click the “Forgot Password” link to receive a new sign-in link.)`
				// + `Someone from Common Good Learning Tools partner support will be reaching out to you soon to offer assistance...`


			let payload = {
				first_name: this.first_name.trim(),
				last_name: this.last_name.trim(),
				user_email: this.email.trim(),
				organization: this.organization.trim(),
				organization_type: this.organization_type.trim(),
				org_job_title: this.org_job_title.trim(),
				reason: this.reason.trim(),
				subdomain: subdomain,
				site_headline: this.site_headline.trim(),

				token_duration: 60*24,
				body_html: email_body_html,
				token_type: 'create_account',
				notify_cglt: `New <a href="https://${domain}">${this.site_config.app_name}</a> patch created.<br>`
					+ `First name: ${this.first_name.trim()}<br>`
					+ `Last name: ${this.last_name.trim()}<br>`
					+ `Email: ${this.email.trim()}<br>`
					+ `Organization: ${this.organization.trim()}<br>`
					+ `Org. Type: ${this.organization_type.trim()}<br>`
					+ `Org. Title: ${this.org_job_title.trim()}<br>`
					+ `Reason: ${this.reason.trim()}<br>`
					+ `Subdomain: ${subdomain} (<a href="https://${subdomain.toLowerCase()}.${domain}">https://${this.subdomain.toLowerCase()}.${domain}</a>)<br>`
					+ `Site Headline: ${this.site_headline.trim()}<br>`
			}

			// for partner's self managed patch registrations, e.g. edsby, we don't need to send support an email
			if (domain != 'satchelcommons.com') {
				payload.notify_cglt = ''
			}
		


			U.loading_start()
			U.ajax('send_token_signin_email', payload, result=>{
				U.loading_stop()
				let msg = ''
				if (result.status == 'subdomain_exists') {
					this.$alert(`A ${this.site_config.app_name} patch for the subdomain you entered (${subdomain}) already exists! Please choose another subdomain.`)
					return

				} else if (result.status != 'ok') {
					console.log(sr('Error in token create account ajax call: $1', result.status))
					this.$alert(`An error ocurred in the registration process. Please contact <a href="mailto:support@commongoodlt.com?subject=Error in ${this.site_config.app_name} registration">support@commongoodlt.com</a> for assistance.`)
					return

				} else {
					msg = `Your ${this.site_config.app_name} Patch has been created`

					if (this.user_info.user_id == 0) {
						msg += `, and a ${this.site_config.app_name} user account has been created for this email address (${this.email.trim()}), with rights to create and manage frameworks for this Patch.<br/><br/>`
						msg += `A message has been sent to your email address with a link you can click to verify your ${this.site_config.app_name} account and set your password. If you don’t receive the link within one minute, <b>please check your spam or junk folder</b>.<br/><br/>`
					} else {
						msg += `, and you have been granted rights to create and manage frameworks for this Patch.<br/><br/>`
					}

					msg += `Click the link below to open the new Patch and start creating CASE® frameworks!<br><br><div class="text-center"><a href="https://${subdomain.toLowerCase()}.${domain}" style="font-size:18px"><b>https://${subdomain.toLowerCase()}.${domain}</b></a></div>`
					
				}
				this.$alert({
					title: 'Patch Created!',
					text:msg,
					dialogMaxWidth: 600,
				}).then(x=>this.$emit('dialog_cancel'))
			})
		},
	}
}
</script>

<style lang="scss">
</style>